import React, {
    ReactNode,
    createContext,
    useContext,
    useState,
    Dispatch,
    SetStateAction,
} from "react";

export interface LanguageContextValue {
    isHE: boolean;
    setIsHE: Dispatch<SetStateAction<boolean>>;
}

export const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);

export const useLanguageContext = (): LanguageContextValue => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error("useLangaugeContext must be used within a LanguageContextProvider");
    }
    return context;
};

interface LanguageContextProviderProps {
    children: ReactNode;
}

const LanguageContextProvider: React.FC<LanguageContextProviderProps> = ({ children }) => {
    const [isHE, setIsHE] = useState<boolean>(false);

    const contextValue: LanguageContextValue = {
        isHE,
        setIsHE
    };

    return <LanguageContext.Provider value={contextValue}>{children}</LanguageContext.Provider>;
};

export default LanguageContextProvider;